import { Stop } from "@vygruppen/vy-train-map";
import { stopNameWithFallback } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/generateStretchName";
import { FC } from "react";
import { DropsBadge, Flex } from "shared/components/Spor";

type StretchNameBadgesProps = {
  stretchNames: string[];
  singleClickedStop: Stop | null;
};

export const StretchNameBadges: FC<StretchNameBadgesProps> = ({
  stretchNames,
  singleClickedStop,
}) => (
  <Flex gap="4px" flexWrap="wrap">
    {stretchNames.map((stretchName) => (
      <DropsBadge
        key={stretchName}
        borderRadius="6px"
        paddingX="12px !important"
        paddingY="3px"
        semantics="success"
      >
        {stretchName}
      </DropsBadge>
    ))}
    {singleClickedStop && (
      <DropsBadge
        borderRadius="6px"
        paddingX="12px !important"
        paddingY="3px"
        semantics="success"
      >
        {stopNameWithFallback(singleClickedStop)}
      </DropsBadge>
    )}
  </Flex>
);
